import { render } from "./BodyComponentTable.vue?vue&type=template&id=65684bd6&scoped=true"
import script from "./BodyComponentTable.vue?vue&type=script&lang=js"
export * from "./BodyComponentTable.vue?vue&type=script&lang=js"

import "./BodyComponentTable.vue?vue&type=style&index=0&id=65684bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65684bd6"]])

export default __exports__